// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--w7txv","link":"_93444fe79c--link--BwwJO","icon":"_93444fe79c--icon--SJUaS","remoteness":"_93444fe79c--remoteness--q8IXp"};